var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Files/Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15832 2.16699C6.64258 2.16699 6.21237 2.56115 6.16733 3.07492C6.07317 4.14911 6.04934 5.22808 6.09591 6.30495C6.03969 6.30871 5.98348 6.31264 5.92728 6.31674L4.93427 6.38912C4.29957 6.43539 3.94477 7.1431 4.28743 7.67935C5.01821 8.82303 5.95985 9.81728 7.06214 10.6091L7.45996 10.8949C7.78251 11.1266 8.21695 11.1266 8.53949 10.8949L8.93732 10.6091C10.0396 9.81728 10.9812 8.82303 11.712 7.67936C12.0547 7.1431 11.6999 6.43539 11.0652 6.38912L10.0722 6.31674C10.016 6.31264 9.95976 6.30871 9.90354 6.30495C9.95011 5.22808 9.92629 4.1491 9.83212 3.07491C9.78709 2.56114 9.35687 2.16699 8.84113 2.16699H7.15832ZM7.12072 6.74348C7.04491 5.552 7.05907 4.35644 7.16309 3.16699H8.83636C8.94038 4.35644 8.95454 5.55199 8.87873 6.74348C8.87023 6.87706 8.91565 7.00846 9.00481 7.10829C9.09397 7.20812 9.21943 7.26803 9.35312 7.27462C9.56868 7.28524 9.78415 7.2984 9.99948 7.31409L10.7206 7.36666C10.081 8.30886 9.27997 9.1317 8.3539 9.79694L7.99973 10.0514L7.64556 9.79694C6.71949 9.1317 5.9185 8.30886 5.27881 7.36666L5.99998 7.31409C6.21531 7.2984 6.43077 7.28524 6.64633 7.27462C6.78002 7.26803 6.90548 7.20812 6.99464 7.10829C7.08381 7.00846 7.12922 6.87706 7.12072 6.74348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 11.3337C3.83301 11.0575 3.60915 10.8337 3.33301 10.8337C3.05687 10.8337 2.83301 11.0575 2.83301 11.3337V12.667C2.83301 13.3113 3.35534 13.8337 3.99967 13.8337H11.9997C12.644 13.8337 13.1663 13.3113 13.1663 12.667V11.3337C13.1663 11.0575 12.9425 10.8337 12.6663 10.8337C12.3902 10.8337 12.1663 11.0575 12.1663 11.3337V12.667C12.1663 12.759 12.0917 12.8337 11.9997 12.8337H3.99967C3.90763 12.8337 3.83301 12.759 3.83301 12.667V11.3337Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.57db6214e01cf330dac5db8e6eab3d66.svg";
export { ForwardRef as ReactComponent };